// functions/length.ts
import "../validator.js";
import { ValidationError } from "../errors/ValidationError.js";
import { nonOptional } from "./nonOptional.js";
var minLength = (minLength2, translationKey) => async (options) => {
  await nonOptional({ translationKey })(options);
  if (!options.value || options.value.length < minLength2)
    throw new ValidationError(`Value of ${options.key} is shorter than ${minLength2}`, {
      key: options.key,
      translationKey
    });
};
var maxLength = (maxLength2, translationKey) => async (options) => {
  await nonOptional({ translationKey })(options);
  if (!options.value || options.value.length > maxLength2)
    throw new ValidationError(`Value of ${options.key} is longer than ${maxLength2}`, {
      key: options.key,
      translationKey
    });
};
export {
  maxLength,
  minLength
};
